// Module
var code = "<a href=\"javascript:;\" tabindex=\"-1\" class=\"btn blue-sharp subFormControl\" id=\"addButton\" data-bind=\"style: _style\"> <i class=\"fa fa-plus-circle\"></i> <span data-bind=\"text: _labels.ADD\"></span> </a>";
// Exports
export default code;